import React, { useState, useEffect, useRef } from "react";
import {
  GearIcon,
  PeopleIcon,
  HomeIcon,
  MortarBoardIcon,
} from "@primer/octicons-react";
import { useLocation, useHistory } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";

import { seo } from "../../components/seo.component";
import AdminDashboardOverview from "./manage/Analytics";
import ManageTopics from "./manage/topics/ManageTopics";
import ManageUsers from "./manage/users/ManageUsers";
import StringService from "../../services/string-service";

import "./admin-dashboard.scss";

const panelNames = ["overview", "manage_users", "manage_topics"];

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function isValidPanelName(nameToCheck) {
  return panelNames.includes(nameToCheck);
}

export default function AdminDashboardPage() {
  const overviewComponent = useRef();
  const query = useQuery();
  const history = useHistory();
  const location = useLocation();

  const getDefaultPanelName = () => {
    const panelFromUrl = query.get("panel");
    if (isValidPanelName(panelFromUrl)) {
      console.log(
        `[PNL Manager] URL contains valid panel name: ${panelFromUrl}`,
      );
      return panelFromUrl;
    } else {
      console.log(
        `[PNL Manager] URL does not contain valid panel name. Using default: ${panelNames[0]}`,
      );
      return panelNames[0];
    }
  };

  const [activePanelKey, setActivePanelKey] = useState(getDefaultPanelName());

  useEffect(() => {
    seo({
      title:
        "Admin » " +
        StringService.capitalizeFirst(activePanelKey).replaceAll("_", " "),
    });
  }, [activePanelKey]);

  useEffect(() => {
    const panelFromUrl = query.get("panel");
    if (isValidPanelName(panelFromUrl) && panelFromUrl !== activePanelKey) {
      setActivePanelKey(panelFromUrl);
    }
  }, [location.search]);

  const switchActivePanel = (eventKey) => {
    if (!isValidPanelName(eventKey)) {
      console.warn(`[PNL Manager] Invalid panel: ${eventKey}`);
      return;
    }

    setActivePanelKey(eventKey);
    updateQueryParameter(eventKey);

    if (panelNames.indexOf(eventKey) === 0) {
      console.log(`[PNL Manager] Triggering static measurement algorithm...`);
      rotateTableHeaders();
    }
  };

  const updateQueryParameter = (panelName) => {
    const params = new URLSearchParams(location.search);
    params.set("panel", panelName);
    history.push({ search: params.toString() });
  };

  const rotateTableHeaders = () => {
    if (overviewComponent.current) {
      overviewComponent.current.rotateTableHeaders();
    }
  };

  return (
    <>
      <Tab.Container
        id="controlled-admin-tabs"
        activeKey={activePanelKey}
        transition={false}
      >
        <Tab.Content>
          <Tab.Pane eventKey={panelNames[0]}>
            <AdminDashboardOverview ref={overviewComponent} />
          </Tab.Pane>
          <Tab.Pane eventKey={panelNames[1]}>
            <ManageUsers />
          </Tab.Pane>
          <Tab.Pane eventKey={panelNames[2]}>
            <ManageTopics />
          </Tab.Pane>
          <Tab.Pane eventKey={panelNames[3]}>
            <p>Comming soon</p>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </>
  );
}
